import { gql } from "apollo-boost";

export const DELETE_INVOICE = gql`
    mutation ($invoice_id: Int!) {
        delete_invoice(invoice_id: $invoice_id){
            success
            message
        }
    }
`